/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import { type CSSProperties, type JSX, type PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { type RequiredTestId } from '@common/components/controls/TestId';
import Icon, { type IconComponentType } from '@common/components/Icon';
import { useCloseMenu } from '@common/components/Menu/MenuContextProvider';
import IconCheck from '@common/components/svgs/common/Check';
import Translated from '@common/components/Translated';
import classnames from '@common/utils/ui/classnames';
import '@common/styles/components/menu.pcss';

type MenuSelectOptionProps = PropsWithChildren<{
  id: string;
  value: string;
  selected?: string;
  onClick: (value: string) => void;
  disabled?: boolean;
  tagName?: keyof JSX.IntrinsicElements;
  style?: CSSProperties;
  leadingIcon?: IconComponentType;
  firstOfGroup?: boolean;
  lastOfGroup?: boolean;
}>;

function MenuSelectOption({
  id,
  value,
  selected,
  onClick,
  disabled,
  tagName = 'p',
  style,
  leadingIcon,
  firstOfGroup,
  lastOfGroup,
  children,
  ...rest
}: RequiredTestId<MenuSelectOptionProps>) {
  const closeMenu = useCloseMenu();
  const { t } = useTranslation();

  return (
    <div
      className={classnames({
        'justify-content-space-between': true,
        menu__option: true,
        'menu__option--select': true,
        'menu__option--group-start': firstOfGroup,
        'menu__option--group-end': lastOfGroup,
        'menu__option--selected': selected === value,
        'menu__option--disabled': disabled,
      })}
      style={style}
      onClick={disabled ? undefined : () => {
        closeMenu(() => onClick(value));
      }}
      onKeyDown={disabled ? undefined : (event) => {
        if (event.code === 'Enter') {
          event.preventDefault();
          closeMenu(() => onClick(value));
        }
      }}
      aria-label={t(id)}
      {...rest}
    >
      <div style={{ display: 'flex' }}>
        {leadingIcon && (
          <span className="menu__option-leading-icon">
            <Icon component={leadingIcon} />
          </span>
        )}
        {children || <Translated className="menu__option-text" id={id} tagName={tagName} />}
      </div>
      <Icon component={IconCheck} size={24} />
    </div>
  );
}

export default MenuSelectOption;
